import { render } from "./CoBrandCrimson.vue?vue&type=template&id=4abeb462&scoped=true"
import script from "./CoBrandCrimson.vue?vue&type=script&lang=js"
export * from "./CoBrandCrimson.vue?vue&type=script&lang=js"

import "./CoBrandCrimson.vue?vue&type=style&index=0&id=4abeb462&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abeb462"]])

export default __exports__